import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import { Tooltip } from 'react-clone-tippy';
import type { MdmEnrollmentBadgesProps } from '../types/interface';
import { MDM_SUPPORTED_ENROLLMENT_TYPES } from '../Constants';
import { getTranslatedText } from '@nile/components';

export const DeviceTypeBadges = ({
  intl,
  supportedDeviceTypes,
  shouldShow
}: MdmEnrollmentBadgesProps) => {
  if (!shouldShow || supportedDeviceTypes.length === 0) {
    return null;
  }

  const getIconAndTooltip = (type: string) => {
    switch (type) {
      case MDM_SUPPORTED_ENROLLMENT_TYPES.BYOD:
        return { icon: 'User', tooltip: 'BYOD' };
      case MDM_SUPPORTED_ENROLLMENT_TYPES.FULLY_MANAGED:
        return { icon: 'FullyManaged', tooltip: 'Fully Managed' };
      case MDM_SUPPORTED_ENROLLMENT_TYPES.SUPERVISED:
        return { icon: 'Supervised', tooltip: 'Supervised' };
      case MDM_SUPPORTED_ENROLLMENT_TYPES.UN_SUPERVISED:
        return { icon: 'UnSupervised', tooltip: 'Un Supervised' };
      default:
        return { icon: 'About', tooltip: '' };
    }
  }

  return (
    <div className="flex disabled-background br-5 p-3-5">
      {supportedDeviceTypes.map((type: string, index: number) => {
        const { icon, tooltip } = getIconAndTooltip(type);
        return <React.Fragment key={index}>
          <Tooltip
            key={index}
            title={getTranslatedText(intl, 'mdm.supports.enrollment.type', { enrollmentType: tooltip })}
            delay={200}
            duration={250}
            position="top"
            inertia
            trigger="mouseenter"
            animation="shift"
            animateFill={false}
            dismissOnMouseOut
            arrow
          >
            <span className="flex actr">
              <SVGIcon name={icon} size="sm" color="var(--sops-primary-500)" />
            </span>
          </Tooltip>
          {
            index < supportedDeviceTypes.length - 1 && (
              <div className="bg-grey w-2"></div>
            )
          }
        </React.Fragment>
      })}
    </div>
  );
};
